

exports.__esModule = true;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = require('angular');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _venmoModels = require('xo-third-party-components/src/venmo-models');

var _checkout = require('xo-models/src/checkout');

var _index = require('xo-models/src/fi/index');

require('xo-address-components/src/add-address/directive');

require('xo-page-components/src/aside-header/directive');

require('xo-ui-components/src/accessibility/directive');

require('xo-ui-components/src/error-tooltip/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$VenmoAddBilling', {
    tag: 'venmo-add-billing',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            optional: false
        },
        sidebar: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            this.country = _squid.$locale.getCountryCodeISO();
            this.billing = true;
            this.address = this.address || { country: this.country };
        },
        populate: function populate() {
            var $el = (0, _jquery2['default'])(this.$element);
            var handleValidation = function handleValidation(res) {
                if (res && res.fields && res.fields.length) {
                    res.fields.forEach(function (field) {
                        if (field.field) {
                            var $field = (0, _jquery2['default'])($el.find('[name="' + field.field + '"]'));

                            if ($field.length === 0 && field.field === 'zip') {
                                $field = (0, _jquery2['default'])($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                            }
                            $field.addClass('backendError');
                            $field.attr('aria-invalid', true);
                        }
                    });
                }

                $el.find('form').find('.backendError, .ng-invalid').first().focus();
            };

            this.done = function () {
                this.goto('checkout.review');
            };

            this.error = function () {
                this.goto('checkout.login', { venmoError: true });
            };

            this.onSubmit = function () {
                this.validateAddress();
            };

            this.validateAddress = function () {
                var self = this;
                var newBilling = new _index.$BillingAddressModel({
                    line1: this.address.line1,
                    line2: this.address.line2,
                    city: this.address.city,
                    state: this.address.state,
                    postal_code: this.address.postal_code,
                    country: this.country,
                    id: '0'
                });

                newBilling.save({
                    success: function success() {
                        if (self && self.models && self.models.checkoutSession && self.models.checkoutSession.plan && self.models.checkoutSession.plan.sources && self.models.checkoutSession.plan.sources['0'] && self.models.checkoutSession.plan.sources['0'].instrument_id) {
                            // if there's a checkout plan
                            var instrumentID = self.models.checkoutSession.plan.sources['0'].instrument_id;

                            self.saveBillingAddressAndReturn(instrumentID);
                        } else if (self.models.checkoutSession.getSelectedStickyInstrument()) {
                            // if there's a Billing Agreement without purchase
                            var _instrumentID = self.models.checkoutSession.getSelectedStickyInstrument().instrument_id;

                            self.saveBillingAddressAndReturn(_instrumentID);
                        } else {
                            // if no instrument, we should error out
                            self.error();
                        }
                    },
                    validation: function validation(res) {
                        handleValidation(res);
                    },
                    error: function error(err) {
                        _logger.$logger.error('venmoBillingAddressValidateError', err);
                        self.error();
                    }
                });
            };

            this.saveBillingAddressAndReturn = function (instrumentID) {
                var self = this;
                var add = {
                    newAddress: {
                        address1: this.address.line1,
                        address2: this.address.line2,
                        city: this.address.city,
                        state: this.address.state,
                        zip: this.address.postal_code,
                        isoCountry: this.country
                    }
                };
                var billingAddress = new _index.$AddBillingAddressModel({ instrumentid: instrumentID });

                billingAddress.save({
                    data: add,
                    success: function success() {
                        _logger.$logger.info(['venmo-billing directive', 'Billing Address', 'added'].join('::'));
                        // Fix: Need to have a better solution
                        _logger.$logger.info(['venmo-billing directive', 'Calling checkout session again'].join('::'));

                        var sessionModel = _checkout.$CheckoutSessionModel.instance(self.token);
                        var cartModel = _checkout.$CheckoutCartModel.instance(self.token);
                        var venmoOnboardModel = _venmoModels.$VenmoOnboardModel.instance(self.token);

                        sessionModel.action('create', {
                            data: {
                                fraudnet_id: cartModel.supplementary && cartModel.supplementary.risk_correlation_id,
                                baToken: cartModel.billing && cartModel.billing.ba_token,
                                user_selected_funding_source: {
                                    dcvv: venmoOnboardModel.dcvv,
                                    product_name: 'VENMO_US_PPMERCHANT_SINGLEUSETOKEN'
                                },
                                is_skip_gfo: true
                            },
                            success: function success() {
                                self.done();
                            }
                        });
                    },
                    validation: function validation(err) {
                        _logger.$logger.error('venmoBillingAddressValidationError', err);
                        self.error();
                    },
                    error: function error(err) {
                        _logger.$logger.error('venmoAddBillingAddressError', err);
                        self.error();
                    }
                });
            };
        }
    }
});


_angular.noop;

_squid.$Component;

_squid.$locale;

_logger.$logger;

_venmoModels.$VenmoOnboardModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_index.$BillingAddressModel;

_index.$AddBillingAddressModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-third-party-components/src/venmo-billing/directive.js
// module id = ../node_modules/xo-third-party-components/src/venmo-billing/directive.js
// module chunks = 0